import { render, staticRenderFns } from "./MotivoNaoVendaList.vue?vue&type=template&id=0b19ea49&scoped=true"
import script from "./MotivoNaoVendaList.vue?vue&type=script&lang=js"
export * from "./MotivoNaoVendaList.vue?vue&type=script&lang=js"
import style0 from "./MotivoNaoVendaList.vue?vue&type=style&index=0&id=0b19ea49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b19ea49",
  null
  
)

export default component.exports